import { useState } from "react";
import { toast } from "sonner";
import { ROLE_DESC, ROLE_LABEL, ROLE_ORDER, roleLabel, roleText, useOrg } from "./org";

export const RoleName = ({ role }) => roleLabel(useOrg().membership, role);

export const RoleNames = () => {
  const { api, membership, reload } = useOrg();
  const isOwner = membership.role === "owner";
  const current = Object.fromEntries(ROLE_ORDER.map((r) => [r, roleLabel(membership, r)]));
  const [f, setF] = useState(current);
  const [busy, setBusy] = useState(false);
  const changed = ROLE_ORDER.some((r) => f[r] !== current[r]);
  const custom = ROLE_ORDER.some((r) => current[r] !== ROLE_LABEL[r]);
  const put = (labels, msg) => {
    setBusy(true);
    api("/org/role-labels", { method: "PUT", body: { labels } })
      .then((r) => { setF(r.role_labels); toast.success(msg); reload(); }).catch((e) => toast.error(e.message)).finally(() => setBusy(false));
  };
  return (
    <section className="mt-14 pt-10 border-t border-line" data-testid="role-names">
      <p className="t-label">Team & Roles</p>
      <h2 className="t-title mt-2">Customize role names</h2>
      <p className="t-meta mt-2">Rename roles to match your church. A new name never changes what that role can do.{!isOwner && ` ${roleLabel(membership, "owner")} only can change these.`}</p>
      <ul className="mt-6 space-y-6">
        {ROLE_ORDER.map((r) => (
          <li key={r} data-testid={`role-name-${r}`}>
            <div className="flex items-baseline justify-between gap-3">
              <label htmlFor={`role-${r}`} className="t-name-sm">{ROLE_LABEL[r]}{current[r] !== ROLE_LABEL[r] && <span className="t-meta font-normal"> · shown as “{current[r]}”</span>}</label>
            </div>
            <p className="t-meta mt-1">{roleText(membership, ROLE_DESC[r])}</p>
            {isOwner && <input id={`role-${r}`} value={f[r]} maxLength={40} onChange={(e) => setF({ ...f, [r]: e.target.value })} className="field h-12 px-3 mt-2" data-testid={`role-name-input-${r}`} />}
          </li>
        ))}
      </ul>
      {isOwner && (
        <div className="flex flex-wrap gap-2 mt-6">
          <button disabled={busy || !changed} onClick={() => put(f, "Role names saved")} className="btn btn-primary" data-testid="role-names-save">Save role names</button>
          {custom && <button disabled={busy} onClick={() => put({}, "Default role names restored")} className="btn btn-outline" data-testid="role-names-restore">Restore defaults</button>}
        </div>
      )}
    </section>
  );
};
